import React from "react";
import { Table } from "semantic-ui-react";
import { getFormattedDate } from "../../helpers/datetime";

const CustomerEventsTable = ({
  headings,
  records,
  selectedRecord,
  onRecordClick,
}) => {
  return (
    <Table sortable>
      <Table.Header>
        <Table.Row>
          {headings.map((x) => (
            <Table.HeaderCell key={x.name}>
              <span>{x.label}</span>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {records &&
          records.map((record, idx) => {
            const triggeredAlert =
              record?.alerts?.length > 0 || record?.alertIds?.length > 0;
            return (
              <Table.Row
                className="clickable"
                key={`${record.id}_${idx}`}
                onClick={() => onRecordClick(record)}
                active={record.id === selectedRecord?.id}
              >
                <Table.Cell>
                  {record?.site?.name}, {record?.site?.town}
                </Table.Cell>
                <Table.Cell>
                  {getFormattedDate(record.interactionDate)}
                </Table.Cell>
                <Table.Cell>{record.reason?.name}</Table.Cell>
                {headings.find((x) => x.name === "triggeredAlert") && (
                  <Table.Cell>{triggeredAlert ? "Yes" : "No"}</Table.Cell>
                )}
                <Table.Cell>{record.id}</Table.Cell>
              </Table.Row>
            );
          })}
      </Table.Body>
    </Table>
  );
};

export default CustomerEventsTable;
